import { render, staticRenderFns } from "./FotoUploadFromUser.vue?vue&type=template&id=64156ed5&scoped=true&"
import script from "./FotoUploadFromUser.vue?vue&type=script&lang=js&"
export * from "./FotoUploadFromUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64156ed5",
  null
  
)

export default component.exports